import { memo, useState, useCallback } from 'react';
import styled from 'styled-components';
import { useFetchCampaignsAssociationSettings, hasCampaignsReadAccess } from './hooks/useFetchCampaignsAssociationSettings';
import { useFetchAssociatedCampaigns } from './hooks/useFetchAssociatedCampaign';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Popover } from 'foundations-components/transitional/components/Popover';
import CampaignsPlatformLabelTag from './CampaignsPlatformLabelTag';
import CampaignsPlatformLabelPopover from './CampaignsPlatformLabelPopover';
import UIButton from 'UIComponents/button/UIButton';
import { getPropertyValue } from 'marketing-platform-lib/utils/crmUtils';
import { useFetchAssociatedAssetObjectId } from './hooks/useFetchAssociatedAssetObjectId';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InlineWrapper = styled.div.withConfig({
  displayName: "CampaignsPlatformLabel__InlineWrapper",
  componentId: "sc-1ci72j9-0"
})(["display:inline;"]);
function CampaignsPlatformLabel({
  objectType,
  assetId,
  crmIdProperty = 'hs_object_id',
  HeaderComponent = ({
    children
  }) => /*#__PURE__*/_jsx(Text, {
    typography: "heading-50",
    children: children
  }),
  className,
  as = 'tag',
  inline = false,
  withEmptyState = true
}) {
  const {
    data: associationSettings,
    loading: associationSettingsLoading
  } = useFetchCampaignsAssociationSettings();
  const [open, setOpen] = useState(false);
  const handleOpenChange = useCallback(() => setOpen(!open), [open]);
  const {
    data: objectId
  } = useFetchAssociatedAssetObjectId({
    objectType,
    assetId,
    crmIdProperty
  });
  const {
    data: associatedCampaigns,
    loading: associatedCampaignsLoading
  } = useFetchAssociatedCampaigns({
    objectType,
    objectId,
    associationSettings,
    isOneToMany: false,
    isFetchingAllObjectProperties: true
  });
  if (associationSettingsLoading || !associationSettings || !associationSettings[objectType] || !hasCampaignsReadAccess(associationSettings, objectType) || !withEmptyState && (!associatedCampaigns || associatedCampaigns.length === 0)) {
    return null;
  }
  const Wrapper = inline ? InlineWrapper : Flex;
  const associatedCampaign = associatedCampaigns === null || associatedCampaigns === void 0 ? void 0 : associatedCampaigns[0];
  return /*#__PURE__*/_jsxs(Wrapper, {
    flexDirection: "column",
    className: className,
    "data-test-id": "campaigns-platform-label",
    "data-test-inline": inline,
    children: [/*#__PURE__*/_jsx(HeaderComponent, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "campaignSelect.formControlLabel"
      })
    }), associatedCampaignsLoading ? null : associatedCampaign ? /*#__PURE__*/_jsx(Popover, {
      open: open,
      onOpenChange: handleOpenChange,
      content: /*#__PURE__*/_jsx(CampaignsPlatformLabelPopover, {
        campaignCrmObject: associatedCampaign
      }),
      inlineSize: "360px",
      children: as === 'tag' ? /*#__PURE__*/_jsx(CampaignsPlatformLabelTag, {
        onClick: handleOpenChange,
        campaignCrmObject: associatedCampaign
      }) : /*#__PURE__*/_jsx(UIButton, {
        onClick: handleOpenChange,
        use: "link",
        children: getPropertyValue(associatedCampaign, 'hs_name')
      })
    }) : /*#__PURE__*/_jsx("span", {
      "data-test-id": "empty-campaigns-platform-label",
      children: "-"
    })]
  });
}
export default /*#__PURE__*/memo(CampaignsPlatformLabel);